export default "__VITE_ASSET__URcOrNi0__"